import clientAxios from '../../clients/clientAxios';
import React, { useState, useEffect } from 'react';
import LoadingScreen from '../../Layout/LoadingScreen';
import { Form, Button, Container } from 'react-bootstrap';
import { notify } from 'react-notify-toast';

export default function Promotions() {
  const [promotionText, setPromotionText] = useState('');
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchCurrentPromotion();
  }, []);
  
  const fetchCurrentPromotion = async () => {
    try {
      setLoading(true);
      const { data } = await clientAxios.get('/promos');

      if (data?.success && data?.data) {
        setPromotionText(data.data.promotionText || '');
        setActive(data.data.active || false);
      }
    } catch (error) {
      notify.show('Error al cargar la promoción', 'error', 3000);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setSaving(true);
      const { data } = await clientAxios.post('/promos', {
        promotionText,
        active,
      });
      if (data?.success) {
        notify.show(
          data.message || 'Promoción guardada correctamente',
          'success',
          3000
        );
      } else {
        notify.show(
          data?.message || 'No se pudo guardar la promoción',
          'error',
          3000
        );
      }
    } catch (error) {
      notify.show('Error al guardar la promoción', 'error', 3000);
    } finally {
      setSaving(false);
    }
  };
  if (loading) {
    return <LoadingScreen customText="Cargando promoción..." />;
  }

  return (
    <Container>
      <div className="bg-light rounded shadow p-3">
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Promoción</Form.Label>
            <Form.Control
              required
              as="textarea"
              name="promotionText"
              value={promotionText}
              onChange={(e) => setPromotionText(e.target.value)}
              disabled={saving}
              maxLength={300}
              rows={3}
            />
            <Form.Text className="text-muted">
              {promotionText.length}/300 caracteres
            </Form.Text>
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Check
              type="switch"
              id="active-switch"
              label={active ? 'Activa' : 'Inactiva'}
              checked={active}
              onChange={(e: any) => setActive(e.target.checked)}
              disabled={saving}
            />
          </Form.Group>
          <Button variant="success" type="submit" disabled={saving}>
            {saving ? 'Guardando...' : 'Guardar'}
          </Button>
        </Form>
      </div>
    </Container>
  );
}
